import { ActivatedRoute } from '@angular/router';

export default class RouteUtils {
  static getEntityId(route: ActivatedRoute | null): string | undefined {
    if (route) {
      const { params } = route.snapshot;
      const [, entityId] = Object.entries<string>(params)[0];
      return entityId as string;
    }
    return undefined;
  }
}
